import Header from './components/Header';
import Hero from './components/Hero';
import Sobre from './components/Sobre';
import Principios from './components/Principios';
import Diferenciais from './components/Diferenciais';
import ComoFunciona from './components/ComoFunciona';
import Contato from './components/Contato';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="font-sans">
      <Header />
      <Hero />
      <Sobre />
      <Principios />
      <Diferenciais />
      <ComoFunciona />
      <Contato />
      <Footer />
    </main>
  );
}
